import { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client'; // Use imported client
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Building2 } from 'lucide-react';

export default function ForgotPortalPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: 'https://app.callsparker.com/portal/reset-password*',
    });

    if (error) {
      setError(error.message);
    } else {
      setMessage('Check your email for a password reset link!');
    }
  };

  return (
    <div className='min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-muted/30 to-background p-4'>
      <div className='w-full max-w-md space-y-8'>
        {/* Logo and Header */}
        <div className='text-center space-y-4'>
          <div className='mx-auto w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center'>
            <Building2 className='w-6 h-6 text-primary' />
          </div>
          <p className='text-muted-foreground'>
            Power your B2B voice prospecting with AI
          </p>
        </div>
        {/* Request Password Reset Form */}

        <Card className='border-2'>
          <CardHeader className='space-y-1'>
            <CardTitle className='text-2xl font-semibold'>
              Forgot Password
            </CardTitle>
            <CardDescription>Request password reset</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleResetPassword} className='space-y-4'>
              <div className='space-y-2'>
                <Label htmlFor='email'>Email</Label>
                <Input
                  id='email'
                  type='email'
                  placeholder='Enter email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className='h-11'
                />
              </div>
              <Button type='submit' className='w-full h-11'>
                Send Reset Link
              </Button>
            </form>
            <p className='text-center text-sm text-muted-foreground mt-4'>
              Remembered your password?&nbsp;
              <Link to='/portal/auth' className='text-blue-500 hover:underline'>
                Sign in
              </Link>
            </p>
            {message && <p>{message}</p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
